import React from "react";

import { faChevronDown } from "@fortawesome/pro-solid-svg-icons/faChevronDown";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Dropdown from "antd/es/dropdown";
import { MenuProps } from "antd/es/menu";
import Skeleton from "antd/es/skeleton";
import { defineMessages, useIntl } from "react-intl";

import Located from "@mapmycustomers/shared/types/base/Located";
import { convertCoordinatesToLongLat } from "@mapmycustomers/shared/util/geo/GeoService";
import { Button } from "@mapmycustomers/ui";

import SingleLineAddress from "@app/component/field/SingleLineAddress";
import Interactive from "@app/component/map/FeaturedMap/essentials/controls/Interactive";
import { formatCoordinates } from "@app/util/formatters";

import styles from "./DropPin.module.scss";

const messages = defineMessages({
  cancel: {
    id: "map.tool.dropPin.annotation.cancel",
    defaultMessage: "Cancel",
    description: "Drop Pin Annotation Popover Cancel button title",
  },
  create: {
    id: "map.tool.dropPin.annotation.create",
    defaultMessage: "Create",
    description: "Drop Pin Annotation Popover Create button title",
  },
  createCompany: {
    id: "map.tool.dropPin.annotation.createMenu.company",
    defaultMessage: "Create as Company",
    description: "Create as Company menu item title",
  },
  createPerson: {
    id: "map.tool.dropPin.annotation.createMenu.person",
    defaultMessage: "Create as Person",
    description: "Create as Person menu item title",
  },
});

interface Props {
  address?: Located;
  coordinates: GeolocationCoordinates;
  loading?: boolean;
  onCancel: () => void;
  onCreateCompany: () => void;
  onCreatePerson: () => void;
  onMenuItemClick?: () => void;
  title: string;
}

const DropPin: React.FC<Props> = ({
  address,
  coordinates,
  loading,
  onCancel,
  onCreateCompany,
  onCreatePerson,
  onMenuItemClick,
  title,
}) => {
  const intl = useIntl();
  const menuItems: MenuProps["items"] = [
    {
      key: "1",
      label: intl.formatMessage(messages.createCompany),
      onClick: onCreateCompany,
    },
    {
      key: "2",
      label: intl.formatMessage(messages.createPerson),
      onClick: onCreatePerson,
    },
  ];

  return (
    <div className={styles.container}>
      <Interactive>
        <div className={styles.content}>
          <div className={styles.title}>{title}</div>
          {loading ? (
            <Skeleton loading title={false} />
          ) : (
            <>
              <SingleLineAddress address={address} />
              <div className={styles.coordinates}>
                {formatCoordinates(convertCoordinatesToLongLat(coordinates))}
              </div>
              <div className={styles.footer}>
                <Button onClick={onCancel}>{intl.formatMessage(messages.cancel)}</Button>
                <Dropdown menu={{ items: menuItems, onClick: onMenuItemClick }} trigger={["click"]}>
                  <Button rightIcon={<FontAwesomeIcon icon={faChevronDown} />} type="primary">
                    {intl.formatMessage(messages.create)}
                  </Button>
                </Dropdown>
              </div>
            </>
          )}
        </div>
      </Interactive>
    </div>
  );
};

export default DropPin;
